import { addonApi } from 'apiConnector/addon';
import { tabRemoved } from 'epic/workspace/common/tabs/tabsEpics/tabRemoved';
import type { AddonFormResult } from 'models/forms/AddonFormResult';
import { ofType } from 'redux-observable';
import type { Observable, SchedulerLike } from 'rxjs';
import { of } from 'rxjs';
import { catchError, mergeMap, takeUntil, timeoutWith } from 'rxjs/operators';
import {
  addonFormReceived,
  addonFormRequestFailed,
  addonFormRequestTimedOut,
  addonFormReset,
  addonFormResetFailed,
} from 'state/addonForm/addonForm.action';
import * as actionTypes from 'state/addonForm/addonForm.actionTypes';
import { addonFormDefaultingThunk } from 'state/addonManagementForm/addonManagementForm.thunks';
import type { EpicWithThunk } from 'state/state.common';

export interface FetchAddonApi {
  fetchFormValues(tabId: string, productId: string, rfqId: string): Observable<AddonFormResult>;
}

export function fetchAddonFormEpic(timeoutInMillis: number = 60000, appScheduler?: SchedulerLike): EpicWithThunk {
  return (actions$, state$, { oldHttpClient }) => {
    const addonFormRequested$ = actions$.pipe(ofType(actionTypes.ADDON_FORM_REQUESTED));

    return addonFormRequested$.pipe(
      mergeMap(({ tabId, productId, rfqId }) => {
        const tabRemoved$ = tabRemoved(actions$, tabId, state$);

        return addonApi(oldHttpClient)
          .fetchFormValues(tabId, productId, rfqId)
          .pipe(
            takeUntil(tabRemoved$),
            mergeMap(addonFormResult =>
              of(addonFormReceived(tabId, addonFormResult), addonFormDefaultingThunk(tabId, productId)),
            ),
            catchError(error => of(addonFormRequestFailed(tabId, productId, error.message || 'default form failed'))),
            timeoutWith(timeoutInMillis, of(addonFormRequestTimedOut(tabId, productId)), appScheduler),
          );
      }),
    );
  };
}
export function resetAddonFormEpic(timeoutInMillis: number = 60000, appScheduler?: SchedulerLike): EpicWithThunk {
  return (actions$, state$, { oldHttpClient }) => {
    const addonFormRequested$ = actions$.pipe(ofType(actionTypes.ADDON_FORM_RESET_REQUESTED));

    return addonFormRequested$.pipe(
      mergeMap(({ tabId, productId, rfqId }) => {
        const tabRemoved$ = tabRemoved(actions$, tabId, state$);

        return addonApi(oldHttpClient)
          .fetchFormValues(tabId, productId, rfqId)
          .pipe(
            takeUntil(tabRemoved$),
            mergeMap(addonFormResult => of(addonFormReset(tabId, addonFormResult))),
            catchError(error => of(addonFormResetFailed(tabId, error.message || 'default form failed'))),
            timeoutWith(
              timeoutInMillis,
              of(addonFormResetFailed(tabId, `Timeout after ${timeoutInMillis}ms`)),
              appScheduler,
            ),
          );
      }),
    );
  };
}
